import { Socket } from 'phoenix'
import store from './store'
import { getSessionData } from 'redux-simple-auth'

const phoenixSocket = new Socket(`${process.env.REACT_APP_SOCKET_URL}/socket`, {
  heartbeatIntervalMs: 10000,
  params: {
    get token() {
      return getSessionData(store.getState()).token
    }
  }
})

export default phoenixSocket



// WEBPACK FOOTER //
// ./src/config/phoenixSocket.js